import script from "./Search.vue?vue&type=script&setup=true&lang=js"
export * from "./Search.vue?vue&type=script&setup=true&lang=js"

import "./Search.vue?vue&type=style&index=0&id=1cab322e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cab322e"]])

export default __exports__